var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.25 11.8308L11.2915 11.8101C11.8646 11.5235 12.5099 12.0412 12.3545 12.6628L11.6455 15.4988C11.4901 16.1205 12.1354 16.6381 12.7085 16.3516L12.75 16.3308M21 12.5808C21 17.5514 16.9706 21.5808 12 21.5808C7.02944 21.5808 3 17.5514 3 12.5808C3 7.61025 7.02944 3.58081 12 3.58081C16.9706 3.58081 21 7.61025 21 12.5808ZM12 8.83081H12.0075V8.83831H12V8.83081Z",
    stroke: "#0F172A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoMore);
export default __webpack_public_path__ + "static/media/info-more.d825a32ee77ec2e9ddc2e19607d1d314.svg";
export { ForwardRef as ReactComponent };